import { createReducer, on } from '@ngrx/store';
import { ASSIGNMENT_ACTIONS } from '../actions/assignment.actions';
import { AssignmentState } from '../types/config.type';

export const ASSIGNMENT_FEATURE_KEY = 'assignment';

export const initialState: AssignmentState = {
  currentAssignment: null,
  currentForm: null,
  error: null,
  searchEntity: null,
  searchQuery: null,
  searchResults: null,
};

export const assignmentReducer = createReducer(
  initialState,
  on(ASSIGNMENT_ACTIONS.startNewAssignment, (state, assignment) => ({
    ...state,
    currentAssignment: assignment,
    currentForm: null,
    targetType: assignment.targetType,
    targetId: assignment.targetId,
    loading: true,
    error: null,
  })),
  on(ASSIGNMENT_ACTIONS.switchForm, (state, form) => ({
    ...state,
    currentForm: form,
    searchResults: null,
    searchQuery: null,
    searchEntity: null,
    error: null,
  })),
  on(ASSIGNMENT_ACTIONS.searchEntity, (state, { query, entity }) => ({
    ...state,
    searchQuery: query,
    searchEntity: entity,
    loading: true,
    error: null,
  })),
  on(ASSIGNMENT_ACTIONS.foundEntity, (state, { entity }) => ({
    ...state,
    searchResults: entity,
    loading: false,
    error: null,
  })),
  on(
    ASSIGNMENT_ACTIONS.assignEntity,
    (state, { targetType, targetId, entity }) => ({
      ...state,
      targetType,
      targetId,
      assignedEntity: entity,
      loading: true,
      error: null,
    }),
  ),
  on(ASSIGNMENT_ACTIONS.searchEntitySuccess, (state, { result }) => ({
    ...state,
    searchResults: result,
    loading: false,
    error: null,
  })),
  on(ASSIGNMENT_ACTIONS.searchEntityFailure, (state) => ({
    ...state,
    searchResults: null,
    loading: false,
    error: true,
  })),
);
